import { FC } from 'react';

const ChevronIcon: FC = () => {
    return (
        <svg
            className="icon br-icon-label"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1113_2718)">
                <path
                    className="-path"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M-5.24537e-07 12C-8.14212e-07 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 -2.34861e-07 12 -5.24537e-07C5.373 -8.14212e-07 -2.34861e-07 5.373 -5.24537e-07 12ZM14.47 10.47L12 12.94L9.53 10.47L8.47 11.53L11.47 14.53L12 15.06L12.53 14.53L15.53 11.53L14.47 10.47Z"
                    fill="currentColor"
                />
                <path className="-stroke" d="M9 11L12 14L15 11" stroke="white" strokeWidth="1.5" />
            </g>
            <defs>
                <clipPath id="clip0_1113_2718">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ChevronIcon;
